import { FC } from 'react'
import { Typography } from '@mui/material'
import { IconWrapper, LicenseItemWrapper, ContentWrapper } from './licenseItem.styles'
import SSMLicenseDetailsTooltip from '../../../../../components/tooltip/SSMLicenseDetailsTooltip'

interface Props {
  icon: JSX.Element
  label: string
  value: JSX.Element
  tooltipValue?: any
}

const LicenseItem: FC<Props> = ({ icon, label, value, tooltipValue }) => {
  const content = (
    <LicenseItemWrapper className="license-item-wrapper">
      <IconWrapper className="icon-wrapper">{icon}</IconWrapper>
      <ContentWrapper className="content-wrapper">
        <Typography className="label">{label}</Typography>
        {value}
      </ContentWrapper>
    </LicenseItemWrapper>
  )

  // Only show tooltip if tooltipValue is provided and it's a cost/count field
  if ((label === 'Annual license cost' || label === 'Number of licenses') && tooltipValue) {
    return (
      <SSMLicenseDetailsTooltip placement="bottom" title={tooltipValue}>
        {content}
      </SSMLicenseDetailsTooltip>
    )
  }

  return content
}

export default LicenseItem
